<div class="scheduler__agenda-container">
    <ng-template #content>
        <transflo-scheduler-modal [shouldUpdateDelete]="true" [currentEvent]="currentEvent"
            (closeModal)='closeModal($event)'>
        </transflo-scheduler-modal>
    </ng-template>
    <transflo-normal-agenda (openUpdateEventModal)="openUpdateEventModal($event)" *ngIf="normalAgendaIsActive">
    </transflo-normal-agenda>
    <transflo-flagged-agenda (openUpdateEventModal)="openUpdateEventModal($event)" *ngIf="flagIsActive">
    </transflo-flagged-agenda>

    <transflo-event-details [eventId]="eventId" *ngIf="eventId > 0">
    </transflo-event-details>
</div>